








































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import ProbabilisticChart from "@/modules/lcca/views/components/ProbablisticChart.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import QuickHelp from "@/views/components/input/QuickHelp.vue";
import {UnitSystem} from "@/interfaces/units";
import {
  IPerRoadLayerImperial,
  IPerRoadLayerMetric,
  IPerRoadSeasonImperial,
  IPerRoadSeasonMetric,
  PerRoadLayerType,
} from "@/modules/perRoad/interfaces/perRoad";
import ProbabilisticInputs from "@/modules/lcca/views/components/ProbablisticInputs.vue";
import {getPdfFromDistribution} from "@/lib/monteCarlo/pdf";
import {poissonRatios} from "@/modules/perRoad/lib/poissonRatio";
import {DistributionTypes} from "@/lib/monteCarlo/interfaces";
import {perRoadStore} from "@/store/store";
import {newLayerFunctionsByType, setAcLayerModulusBySeason} from "@/modules/perRoad/lib/layers/createNewLayer";
import {v4 as uuidv4} from "uuid";

const echarts = require("echarts");

@Component({
  components: {
    ProbabilisticInputs,
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class PrLayerEditor extends Vue {
  @Prop() layer!: IPerRoadLayerImperial | IPerRoadLayerMetric;

  @Prop() layerImperial!: IPerRoadLayerImperial;

  @Prop() layerNumber!: number;

  @Prop() seasons!: IPerRoadSeasonImperial[] | IPerRoadSeasonMetric[];

  @Prop() seasonsImperial!: IPerRoadSeasonImperial[];

  @Prop() validations!: any;


  uniquePlotId = uuidv4().toString();

  // @PropSync('alternative') alt!: ILccaAlternative;
  modulusKey = 0;

  thicknessKey = 0;

  layerTypes = PerRoadLayerType;

  get layerMaterialTypeOptions() {
    return Object.values(PerRoadLayerType).map((value) => ({value, text: value}));
  }

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  sync() {
    this.createModulusSparkline();
    this.createThicknessSparkline();
    this.$emit("sync");
  }

  toggleLayerEnabled() {
    this.layer.enabled = !this.layer.enabled;
    this.sync();
  }

  mounted() {
    this.createModulusSparkline();
    this.createThicknessSparkline();
  }

  updated() {
    this.createModulusSparkline();
    this.createThicknessSparkline();
  }

  seasonIsDisabled(seasonName: string) {
    const season = this.seasonsImperial.filter((s) => s.name === seasonName)[0];
    return season ? !season.enabled : true;
  }

  /**
   * New layer creation
   */

  createNewLayer() {
    const newLayerType = this.layer.type;
    const newLayerFcn = newLayerFunctionsByType[newLayerType];
    const newLayer = newLayerFcn(newLayerType, this.seasonsImperial);

    newLayer.name = this.layer.name;

    // this.layer = newLayer;
    this.updateThicknessKey();
    this.updateModulusKey();

    this.$emit("setNewLayer", newLayer);
  }

  /**
   * Poisson's ratio
   */

  get layerPoissonDefaults() {
    // @ts-ignore
    return poissonRatios[this.layer.type] ? poissonRatios[this.layer.type] : {min: 0, max: 1};
  }

  /**
   * PG Grade
   */
  get pgGradeHighOptions() {
    /**
     * PG Grade High is the superpave high-temp performance limit for the pavement in deg C. Increments by 6 degrees C
     * https://pavementinteractive.org/reference-desk/materials/asphalt/superpave-performance-grading/
     */
    const values = [];
    for (let i = 46; i <= 82; i += 6) {
      values.push(i);
    }
    return values.map((v) => ({value: v, text: v}));
  }

  get pgGradeLowOptions() {
    /**
     * PG Grade low is the superpave low-temp performance limit for the pavement in deg C. Increments by 6 degrees C
     * https://pavementinteractive.org/reference-desk/materials/asphalt/superpave-performance-grading/
     */
    const values = [];
    for (let i = -40; i <= -10; i += 6) {
      values.push(i);
    }
    return values.map((v) => ({value: v, text: v}));
  }

  setPgGrade() {
    this.layerImperial = setAcLayerModulusBySeason(this.layerImperial, this.seasonsImperial);
  }

  /**
   * Modulus interface
   */

  get modulusUnit() {
    return this.unitSystemIsImperial ? "psi" : "MPa";
  }

  get modulusModalId() {
    return `layer-${this.uniquePlotId}-modulus-modal`;
  }


  get modulusSparklineId() {
    return `layer-${this.uniquePlotId}-modulus-sparkline`;
  }


  get modulusPdfData() {
    const pdfs: any[] = [];

    // If it's AC, get a list of PDFs based on season
    if (this.layer.unitSystem === UnitSystem.Imperial) {
      this.layer.modulus_psi.forEach((dist) => {
        if (!this.seasonIsDisabled(dist.name)) {
          pdfs.push(getPdfFromDistribution(dist));
        }
      });
    } else {
      this.layer.modulus_mpa.forEach((dist) => {
        if (!this.seasonIsDisabled(dist.name)) {
          pdfs.push(getPdfFromDistribution(dist));
        }
      });
    }
    return pdfs;
  }

  modulusChart: any = null;

  createModulusSparkline() {
    if (this.modulusChart === null) {
      const el = document.getElementById(this.modulusSparklineId);
      this.modulusChart = echarts.init(el);
    }

    // Build one for each season
    // const series = this.seasons.map((season) => {
    //   if ([PerRoadLayerType.AC, PerRoadLayerType.CRACKED_AC].includes(this.layer.type)){
    //     const modulus = temperatureAdjustedStiffnessPsi(this.layer.pgGradeHigh, season.tem)
    //
    //     const pdf = getPdfFromDistribution()
    //
    // });

    const distNames = ((): string[] => {
      if (this.layer.unitSystem === UnitSystem.Imperial) {
        return this.layer.modulus_psi.map((d) => d.name);
      }
      return this.layer.modulus_mpa.map((d) => d.name);
    })();

    const series = this.modulusPdfData.map((pdf, i) => ({
      type: "line",
      data: pdf,
      name: distNames[i],
      showSymbol: false,
      areaStyle: {},
      tooltip: {
        formatter: "{a0}",
      },
    }));

    this.modulusChart.setOption({
      animation: false,
      grid: {
        top: 10,
        right: 25,
        bottom: 20,
        left: 10,
      },
      tooltip: {
        trigger: "axis",
        formatter(obj: any) {
          return `<div>${obj[0].seriesName}: ${obj[0].value[0].toFixed(2)}</div>`;
        },
      },
      xAxis: {
        scale: false,
        splitLine: {
          show: false,
        },
      },
      yAxis: {
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      series,
    });
  }

  updateModulusKey() {
    this.modulusKey += 1;
    console.log("moduluskey", this.modulusKey);
  }

  /**
   *
   * Thickness interface
   *
   */

  get thicknessUnit() {
    return this.unitSystemIsImperial ? "in" : "cm";
  }

  get thicknessModalId() {
    return `layer-${this.uniquePlotId}-thickness-modal`;
  }

  get thicknessSparklineId() {
    return `layer-${this.uniquePlotId}-thickness-sparkline`;
  }

  get thicknessPdfData() {
    if (this.layer.unitSystem === UnitSystem.Imperial) {
      return getPdfFromDistribution(this.layer.thickness_in);
    }
    return getPdfFromDistribution(this.layer.thickness_cm);
  }

  thicknessChart: any = null;

  createThicknessSparkline() {
    if (this.thicknessChart === null) {
      const el = document.getElementById(this.thicknessSparklineId);
      this.thicknessChart = echarts.init(el);
    }

    const {layer} = this;
    const layerThicknessDist = layer.unitSystem === UnitSystem.Imperial ? layer.thickness_in : layer.thickness_cm;

    const pdf = this.thicknessPdfData;

    const series = (function () {
      // Deterministic
      if (layerThicknessDist.prob === DistributionTypes.deterministic) {
        return [
          {
            type: "scatter",
            name: layerThicknessDist.name,
            data: [[layerThicknessDist.mean, 1]],
            symbolSize: 15,
            tooltip: {
              formatter: "{a0}: {c0}",
            },
          },
          // {
          //   type: 'line',
          //   data: pdf,
          //   showSymbol: false,
          //   areaStyle: {},
          // },
        ];
      }

      // Regular probability distribution
      return [{
        type: "line",
        name: layerThicknessDist.name,
        data: pdf,
        showSymbol: false,
        areaStyle: {},
        tooltip: {},
      }];
    }());

    this.thicknessChart.setOption({
      animation: false,
      grid: {
        top: 10, right: 10, bottom: 20, left: 10,
      },
      tooltip: {
        trigger: "axis",
        formatter(obj: any) {
          return `<div>${obj[0].seriesName}: ${obj[0].value[0].toFixed(2)}</div>`;
        },
      },
      xAxis: {
        scale: false,
        min: 0,
        max() {
          if (layerThicknessDist.prob === DistributionTypes.deterministic) {
            return 2 * (layerThicknessDist.mean || 1);
          }
          return Math.ceil(pdf[pdf.length - 1][0]);
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: true,
        },
      },
      yAxis: {
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      series,

      // series: {
      //   type: 'line',
      //   data: this.thicknessPdfData,
      //   showSymbol: false,
      //   areaStyle: {},
      // },
    });
  }

  updateThicknessKey() {
    this.thicknessKey += 1;
  }
}
